'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  ProductSearchPagination,
  ProductSearchRefinements,
  ProductSearchRefinementsButton,
  ProductSearchRefinementSortingSelect,
  ProductSearchRefinementStateProvider,
} from '../../../product-search'
import { SearchPageAdBannerTop } from '../../ad-banner/SearchPageAdBannerTop'
import { SearchPageResultHeader } from '../SearchPageResultHeader'
import { SearchPageResultList } from '../SearchPageResultList'

export const SearchPageResultsFound: FC = () => {
  return (
    <div className="hidden flex-col gap-3 only:flex desktop:gap-6">
      <SearchPageResultHeader />
      <ProductSearchRefinementsButton className="desktop:hidden" />

      <div className="grid gap-4 pt-5 desktop:grid-cols-10 desktop:items-start desktop:gap-6 desktop:pt-0">
        <div
          className="hidden flex-col gap-6 rounded-lg bg-light-primary-medium p-4 desktop:col-span-3 desktop:flex"
          data-qa-id="product-filter-variant"
        >
          <h5 className="text-l font-medium">
            <FormattedMessage id="general.label.filterSearch" />
          </h5>

          <div className="flex flex-col gap-4">
            <ProductSearchRefinementStateProvider>
              <ProductSearchRefinementSortingSelect />
              <ProductSearchRefinements />
            </ProductSearchRefinementStateProvider>
          </div>
        </div>
        <div className="desktop:col-span-7">
          <SearchPageAdBannerTop className="mb-9" />
          <SearchPageResultList />
          <ProductSearchPagination />
        </div>
      </div>
    </div>
  )
}
